import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { GALLERY_STRIP } from "@/lib/data";

export default function GalleryStrip() {
    return (
        <section data-testid="gallery-strip" className="bg-bone py-12 md:py-20">
            <div className="container-wide">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
                    {/* Tall portrait image (left) */}
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        className="md:col-span-7 md:row-span-2 relative overflow-hidden aspect-[4/5] md:aspect-auto md:h-[720px] group"
                    >
                        <picture>
                            {GALLERY_STRIP.tall.urlMobile && (
                                <source media="(max-width: 767px)" srcSet={GALLERY_STRIP.tall.urlMobile} />
                            )}
                            <img
                                src={GALLERY_STRIP.tall.url}
                                alt={GALLERY_STRIP.tall.alt}
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                            />
                        </picture>
                    </motion.div>

                    {/* Architectural detail image (top right) */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="md:col-span-5 relative overflow-hidden aspect-[5/4] md:aspect-auto md:h-[348px] group"
                    >
                        <img
                            src={GALLERY_STRIP.detail.url}
                            alt={GALLERY_STRIP.detail.alt}
                            loading="lazy"
                            className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                        />
                    </motion.div>

                    {/* "Your Home, Our Pride" CTA block (bottom right) */}
                    <motion.div
                        data-testid="your-home-our-pride"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, delay: 0.25 }}
                        className="md:col-span-5 relative bg-clay text-bone flex flex-col justify-center px-8 md:px-12 py-16 md:py-0 md:h-[348px] overflow-hidden"
                    >
                        <div className="text-center md:text-left">
                            <div
                                className="font-script text-bone text-4xl md:text-5xl lg:text-6xl leading-tight mb-8 md:mb-10"
                                aria-hidden="true"
                            >
                                Your home, Our pride
                            </div>

                            <Link
                                to="/contact"
                                data-testid="cta-band-contact"
                                className="inline-flex items-center gap-5 border border-bone/80 hover:border-bone hover:bg-bone hover:text-clay text-bone px-8 py-4 text-[11px] tracking-[0.28em] uppercase font-medium transition-all duration-300"
                            >
                                Contact Us
                                <span className="inline-block w-6 h-px bg-current" />
                            </Link>
                        </div>

                        {/* Subtle grain texture overlay */}
                        <div className="grain absolute inset-0" />
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
